import { Component, Injector, Optional } from '@angular/core';

import { FactuurService } from 'src/app/core/service/factuur.service';
import { Factuur } from 'src/app/core/dto/factuur';
import { Filter, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';

@Component({
    selector: 'c-i-j-borculo-factuur-goedkeuren-collection',
    templateUrl: './factuur-collection.component.html'/*,
    styleUrls: ['./factuur-collection.component.css'] */
})
export class FactuurGoedkeurenCollectionComponent extends PagedCollectionComponent<Factuur> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<Factuur>([
      { colDef: 'factuur', prop: x => x.id, searchable: SearchableType.String },
      { colDef: 'nummer', prop: x => x.oldID, searchable: SearchableType.String },
      { colDef: 'groep', prop: x => x.pakbon.project.projectgroep.afdeling, searchable: SearchableType.String },
      { colDef: 'factuurDatum', prop: x => x.factuurDatum, searchable: SearchableType.Date },		
      { colDef: 'pakbon', prop: x => x.pakbon.pakbonnummer, searchable: SearchableType.String },
      { colDef: 'project', prop: x => x.pakbon.project.code, searchable: SearchableType.String },
		  { colDef: 'naam1', prop: x => x.naam1, searchable: SearchableType.String },
		  { colDef: 'plaats', prop: x => x.plaats, searchable: SearchableType.String },
		  { colDef: 'eMail', prop: x => x.eMail, searchable: SearchableType.String },
		  { colDef: 'omschrijving1', prop: x => x.omschrijving1, searchable: SearchableType.String },
      { colDef: 'totaalbedrag', prop: x => x.totaalbedrag, searchable: SearchableType.Number },
      { colDef: 'totaalKalibratieMetKorting', prop: x => x.totaalKalibratieMetKorting, searchable: SearchableType.Number },
      { colDef: 'totaalArtikelen', prop: x => x.totaalArtikelen, searchable: SearchableType.Number },
      { colDef: 'isProForma', prop: x => x.isProForma, searchable: SearchableType.Boolean },
      { colDef: 'goedgekeurdOp', prop: x => x.goedgekeurdOp, searchable: SearchableType.Date },
      { colDef: 'mailDatum', prop: x => x.mailDatum, searchable: SearchableType.Date }
    
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: FactuurService, @Optional() protected filter: Filter<Factuur>, injector: Injector) {
        super('/factuur/goedkeuren', injector, Factuur);
		
        // Nog niet Goedgekeurd
        this.filter.add(this.filterBuilder.equal(x => x.goedgekeurdOp, null),true);
        
        this.orderBy = [-2];

        this.filter.onGetChipLabel(x => x.id, () => 'Factuur');
        this.filter.onGetChipLabel(x => x.oldID, () => 'Nummer');		
        this.filter.onGetChipLabel(x => x.factuurDatum, () => 'Factuurdatum');		
        this.filter.onGetChipLabel(x => x.pakbon.pakbonnummer, () => 'Pakbonnummer');
        this.filter.onGetChipLabel(x => x.pakbon.project.code, () => 'Project');
        this.filter.onGetChipLabel(x => x.naam1, () => 'Naam');
        this.filter.onGetChipLabel(x => x.plaats, () => 'Plaats');		
        this.filter.onGetChipLabel(x => x.eMail, () => 'Email');
        this.filter.onGetChipLabel(x => x.omschrijving1, () => 'Omschrijving');
        this.filter.onGetChipLabel(x => x.totaalbedrag, () => 'Totaalbedrag');
        this.filter.onGetChipLabel(x => x.isProForma, () => 'ProForma');
        this.filter.onGetChipLabel(x => x.goedgekeurdOp, () => 'Goedgekeurd');		
        this.filter.onGetChipLabel(x => x.mailDatum, () => 'Verzonden');        
    }

    ngOnInit() {
      super.ngOnInit();
      
      this.buildCustomActions(config => config.add({
          icon: 'download',
          name: "Export Excel",
          pin: true,
          show: () => this.authScheme.canDo("CIJBorculo.Logic.ExporteerFactuurRequest"),
          fn: () => {
                  this.service.exporteerFacturenExcel(this.filter).toPromise().then(
            (value) => {
              var blob = this.service.ConvertResponseToBlob(value);
                          var url = window.URL.createObjectURL(blob);
                          let anchor = document.createElement('a');
                          anchor.href = url;
                          if (value.fileName) {
                              anchor.setAttribute('download', value.fileName);
                          }
                          anchor.target = '_blank';
                          anchor.click();
                });                
                }
      }));
      
      }

    canDelete() {
      return false;
  }
  
}